export const NDR_PAGE_URL_ALIAS = "ndp-ndr2026";
export const SEASONAL_TAGS = "bhndr2026,bhndp2026";

export const NDP_NDR_METADATA = {
  ndp: {
    title: "NDP 2026: Perbarisan Hari Kebangsaan | Stadium, Negara Singapura",
    description:
      "Saksikan NDP 2026 secara langsung di Stadium Negara sedang Singapura mencecah usia 61 tahun dan selanjutnya. Dapatkan tarikh persembahan, maklumat tiket, jadual raptai dan sorotan di sini.",
    h1: "Hari Kebangsaan 2026",
    name: "NDP 2026",
    startDate: "2026-08-05",
    endDate: "2026-08-13",
  },
  ndr: {
    title:
      "Rapat Hari Kebangsaan 2026 (NDR) - Penstriman Langsung 23 Ogos & Ucapan PM Wong",
    description:
      "PM Lawrence Wong menyampaikan ucapan Rapat Hari Kebangsaan 2026 pada 23 Ogos di ITE Kolej Central. Saksikan secara langsung, dapatkan sorotan, transkrip dan pengumuman utama.",
    h1: "Rapat Hari Kebangsaan 2026",
    name: "NDR 2026",
    startDate: "2026-08-19",
    endDate: "2026-08-25",
  },
};

export const NDP_NDR_SWITCH_DATE = "2026-08-14T00:00:00+08:00"; // Singapore timezone
